// @mui
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
//
import { useLocales } from 'src/locales';
import { ConfirmDialogProps } from './types';
import Draggable from 'react-draggable';

// ----------------------------------------------------------------------

export default function ConfirmDialog({
  title,
  content,
  action,
  open,
  onClose,
  ...other
}: ConfirmDialogProps) {
  const { translate } = useLocales();
  return (
    <Draggable>
      <Dialog fullWidth maxWidth="md" open={open} onClose={onClose} {...other}>
        <DialogTitle sx={{ pb: 2 }}>{title}</DialogTitle>

        {content && <DialogContent sx={{ typography: 'body2' }}> {content} </DialogContent>}

        <DialogActions>
          {action}

          <Button variant="outlined" color="inherit" onClick={onClose}>
            {`${translate('cancel')}`}
          </Button>
        </DialogActions>
      </Dialog>
    </Draggable>
  );
}
